import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { HeaderLayoutComponent } from './components/header-layout/header-layout.component';
import { LandingLayoutComponent } from './components/landing-layout/landing-layout.component';
import {MatCardModule} from '@angular/material/card';
import { LoaderComponent } from './components/loader/loader.component';
import { FooterLayoutComponent } from './components/footer-layout/footer-layout.component';


@NgModule({
  declarations: [
    HeaderLayoutComponent,
    LandingLayoutComponent,
    LoaderComponent,
    FooterLayoutComponent
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    MatCardModule
  ],
  exports:[
    HeaderLayoutComponent,
    LoaderComponent,
    FooterLayoutComponent
  ]
})
export class SharedModule { }
